import { Component, Input } from '@angular/core'
import { AsyncPipe, NgStyle } from '@angular/common';
import { ContentTile, TileComponent } from '@nx-superprep/shared'

export interface NotificationContent {
  icon?: string,
  header?: string,
  text: string,
  textColor?: string,
  color?: string,
  action?: () => void,
  actionText?: string,
}
@Component({
  selector: 'pop-ui-drawer-content-notification',
  standalone: true,
  imports: [NgStyle, AsyncPipe],
  templateUrl: './notification.component.html',
  styleUrls: ['./notification.component.scss'],
})
export class NotificationComponent extends TileComponent {
  private _notification: NotificationContent|undefined
  @Input()
  get notification() { return this._notification }
  set notification(value) {
    this._notification = value
    if (!value) { return }
    this.element = { content: {
      iconName: value.icon,
      title: ''
    } as ContentTile }
  }

  get isActionable() { return this.notification?.action }

  get header() { return this.notification?.header }
  get text() { return this.notification?.text }
  get icon() { return this.notification?.icon }
  get textColor() { return this.notification?.textColor??'transparent' }
  get action() { return this.notification?.action ?? (() => { return })}
  get actionText() { return this.notification?.actionText }

  override get color() { return this.notification?.color??'transparent' }
}
